// Cross-module signal when a Cloud Function answers 402 AI_QUOTA_EXCEEDED.
// The axios interceptor emits; useAiQuota listens so the badge and paywall
// stay in sync even if the client thought the user still had room (or was
// wrongly showing Unlimited from a stale build).

export const AI_QUOTA_EXCEEDED_EVENT = "careerclaw:ai-quota-exceeded";

export const emitAiQuotaExceeded = (detail = {}) => {
  if (typeof window === "undefined" || typeof window.dispatchEvent !== "function") {
    return;
  }
  window.dispatchEvent(
    new CustomEvent(AI_QUOTA_EXCEEDED_EVENT, { detail: detail || {} })
  );
};

// A component that does not hold useAiQuota (the posting fetch / clean-up
// helpers) reports a server-charged AI call here, so the badge on the page
// moves the same way quota.spend() would move it.
export const AI_QUOTA_SPENT_EVENT = "careerclaw:ai-quota-spent";

// detail: { units = 1, sourceId } - sourceId lets the useAiQuota instance that
// spent ignore its own broadcast (it has already moved its badge).
export const emitAiQuotaSpent = (detail = {}) => {
  if (typeof window === "undefined" || typeof window.dispatchEvent !== "function") {
    return;
  }
  window.dispatchEvent(
    new CustomEvent(AI_QUOTA_SPENT_EVENT, { detail: detail || {} })
  );
};

export default {
  AI_QUOTA_EXCEEDED_EVENT,
  emitAiQuotaExceeded,
  AI_QUOTA_SPENT_EVENT,
  emitAiQuotaSpent,
};
